import React, { FC } from 'react';
import Image from 'atomic/image';
import Preview from './assets/images/preview.webp';
import Forbes from './assets/images/forbes.webp';
import Male from './assets/images/male.webp';
import Female from './assets/images/female.webp';
import Wirtualnemedia from './assets/images/wirtualnemedia.webp';
import BusinessInsider from './assets/images/business-insider.webp';
import Google from './assets/images/google.webp';
import Trustpilot from './assets/images/trustpilot.webp';
import AboutUsStructuredData from './components/about-us-structured-data';
import ProductSectionBox from 'modules/product/views/components/product-section-box';
import Icon from 'atomic/icon';
import { SeoLinkRelEnum } from 'modules/seo-module/interfaces/seo-link-rel.enum';
import { LinkTarget } from 'atomic/link/link-target.enum';

import './index.base.scss';

const AboutUsBase: FC = () => (
    <section className="about-us">
        <Image
            className="about-us__image about-us__image--large"
            src={Preview}
            alt="Podgląd"
            show={true}
            width={360}
            height={117}
        />
        <ProductSectionBox
            headerText="O nas – Skąpiec.pl"
            padding="lg"
        >
            <div className="about-us__container">
                <h3 className="about-us__title">Tworzymy nową jakość e-commerce!</h3>
                <p className="about-us__text">
                    Skąpiec.pl to kompleksowy i rzetelny przegląd ofert tysięcy sklepów internetowych, obejmujący
                    miliony produktów i aktualizowany codziennie. Każdy użytkownik bez trudu i ekspresowo znajdzie tu
                    wymarzony produkt za najlepszą cenę.
                </p>
                <p className="about-us__text">
                    Oferujemy szeroki katalog produktów, łatwe wyszukiwanie, rekomendacje zakupowe oraz poradniki i
                    inspirujące treści. Pomagamy robić przemyślane, racjonalne zakupy. To dlatego Skąpiec.pl każdego
                    dnia tak skutecznie przyciąga smart shopperów.
                </p>
                <h3 className="about-us__title">
                    Nasza platforma to idealne miejsce dla sprytnych konsumentów, posiadająca w swojej ofercie:
                </h3>
                <ul>
                    <li className="about-us__item">
                        <div className="about-us__circles" />
                        <div>
                            <h4 className="about-us__header">Szeroki katalog produktów</h4>
                            <p className="about-us__text">
                                Umożliwiamy użytkownikom znalezienie najlepszych ofert z różnorodnych kategorii.
                            </p>
                        </div>
                    </li>
                    <li className="about-us__item">
                        <div className="about-us__circles" />
                        <div>
                            <h4 className="about-us__header">Porównywanie ofert</h4>
                            <p className="about-us__text">
                                Pomagamy w podejmowaniu świadomych wyborów zakupowych dzięki możliwości porównywania
                                ofert od różnych sklepów.
                            </p>
                        </div>
                    </li>
                    <li className="about-us__item">
                        <div className="about-us__circles" />
                        <div>
                            <h4 className="about-us__header">Rankingi i zestawienia</h4>
                            <p className="about-us__text">
                                Ułatwiamy wybór najlepszej opcji zakupowej dzięki listom najbardziej popularnych ofert
                                w obrębie danej kategorii.
                            </p>
                        </div>
                    </li>
                    <li className="about-us__item">
                        <div className="about-us__circles" />
                        <div>
                            <h4 className="about-us__header">Porady i newsy</h4>
                            <p className="about-us__text">
                                Doradzamy w wyborach zakupowych poprzez inspirujące treści oraz atrakcyjną prezentację
                                ofert.
                            </p>
                        </div>
                    </li>
                </ul>
                <h3 className="about-us__title">Przeczytasz o nas w:</h3>
                <ul className="about-us__links">
                    <li>
                        <a
                            className="about-us__link"
                            href="https://www.forbes.pl/handel/zakupy-w-internecie-czego-szukamy-na-skapiecpl/n3fpfty"
                            target={LinkTarget.BLANK}
                            rel={SeoLinkRelEnum.NOFOLLOW_NOOPENER_NOREFERRER}
                            aria-label="Forbes"
                        >
                            <Image
                                className="about-us__image"
                                src={Forbes}
                                alt="Forbes"
                                show={true}
                                width={160}
                                height={60}
                            />
                        </a>
                    </li>
                    <li>
                        <a
                            className="about-us__link"
                            href="https://www.wirtualnemedia.pl/artykul/skapiec-pl-rosnie-najszybciej-blisko-40-proc-wzrost-uzytkownikow-w-ciagu-roku"
                            target={LinkTarget.BLANK}
                            rel={SeoLinkRelEnum.NOFOLLOW_NOOPENER_NOREFERRER}
                            aria-label="Wirtualnemedia"
                        >
                            <Image
                                className="about-us__image"
                                src={Wirtualnemedia}
                                alt="Wirtualnemedia"
                                show={true}
                                width={160}
                                height={60}
                            />
                        </a>
                    </li>
                    <li>
                        <a
                            className="about-us__link"
                            href="https://businessinsider.com.pl/finanse/handel/skapiecpl-rekordowe-wyniki-w-kwieniu/8tq2etg"
                            target={LinkTarget.BLANK}
                            rel={SeoLinkRelEnum.NOFOLLOW_NOOPENER_NOREFERRER}
                            aria-label="Business insider"
                        >
                            <Image
                                className="about-us__image"
                                src={BusinessInsider}
                                alt="Business insider"
                                show={true}
                                width={160}
                                height={60}
                            />
                        </a>
                    </li>
                </ul>
                <h3 className="about-us__title">Jesteśmy częścią Ringier Axel Springer Polska</h3>
                <p className="about-us__text">
                    Skąpiec.pl należy do Grupy Ringier Axel Springer Polska i jest ściśle powiązany z panelem
                    samoobsługowym Onet Ads. Te trzy podmioty współdziałają, oferując na rynku e-commerce kompleksowe
                    rozwiązania z zakresu zakupów online i reklamy internetowej.
                </p>
                <p className="about-us__text">
                    Ringier Axel Springer Polska jest właścicielem Onet.pl, jednego z największych polskich portali
                    internetowych. W 2014 roku przejął 80% udziałów w Skąpiec.pl.
                </p>
                <p className="about-us__text">
                    Z kolei Onet Ads to platforma self-service należąca do RASP. Dzięki niej klienci biznesowi i
                    partnerzy Skąpiec.pl otrzymują błyskawiczny, wygodny dostęp do szeregu narzędzi takich jak m.in.
                    kampanie reklamowe czy możliwość prezentowania produktów na okolicznościowych podstronach.
                </p>
                <h3 className="about-us__title">Nasz Zespół</h3>
                <ul className="about-us__persons">
                    <li className="about-us__person">
                        <Image
                            className="about-us__image about-us__image--small"
                            src={Female}
                            alt="Kobieta"
                            show={true}
                            width={140}
                            height={140}
                        />
                        <h4 className="about-us__header">Mariola Kucharska</h4>
                        <p>E-Commerce Director</p>
                    </li>
                    <li className="about-us__person">
                        <Image
                            className="about-us__image about-us__image--small"
                            src={Female}
                            alt="Kobieta"
                            show={true}
                            width={140}
                            height={140}
                        />
                        <h4 className="about-us__header">Agnieszka Paprocka-Major</h4>
                        <p>Head of E-Commerce Business Development</p>
                    </li>
                    <li className="about-us__person">
                        <Image
                            className="about-us__image about-us__image--small"
                            src={Male}
                            alt="Mężczyzna"
                            show={true}
                            width={140}
                            height={140}
                        />
                        <h4 className="about-us__header">Łukasz Szymański</h4>
                        <p>E-Commerce Product Director</p>
                    </li>
                    <li className="about-us__person">
                        <Image
                            className="about-us__image about-us__image--small"
                            src={Male}
                            alt="Mężczyzna"
                            show={true}
                            width={140}
                            height={140}
                        />
                        <h4 className="about-us__header">Bartłomiej Mączyński</h4>
                        <p>Head of E-Commerce Performance Marketing</p>
                    </li>
                    <li className="about-us__person">
                        <Image
                            className="about-us__image about-us__image--small"
                            src={Male}
                            alt="Mężczyzna"
                            show={true}
                            width={140}
                            height={140}
                        />
                        <h4 className="about-us__header">Kornel Karbowniczek</h4>
                        <p>Head of Content Commerce</p>
                    </li>
                </ul>
                <h3 className="about-us__title">Recenzje naszych klientów</h3>
                <ul className="about-us__images">
                    <li>
                        <a
                            className="about-us__rating about-us__rating--google"
                            href="https://maps.app.goo.gl/Hcxpzzs7CV1j4i7J9"
                            target={LinkTarget.BLANK}
                            rel={SeoLinkRelEnum.NOFOLLOW_NOOPENER_NOREFERRER}
                            aria-label="Google"
                        >
                            <Image
                                className="about-us__image"
                                src={Google}
                                alt="Google"
                                show={true}
                                width={306}
                                height={96}
                            />
                        </a>
                    </li>
                    <li>
                        <a
                            className="about-us__rating about-us__rating--trustpilot"
                            href="https://pl.trustpilot.com/review/skapiec.pl"
                            target={LinkTarget.BLANK}
                            rel={SeoLinkRelEnum.NOFOLLOW_NOOPENER_NOREFERRER}
                            aria-label="Trustpilot"
                        >
                            <Image
                                className="about-us__image"
                                src={Trustpilot}
                                alt="Trustpilot"
                                show={true}
                                width={318.5}
                                height={96}
                            />
                        </a>
                    </li>
                </ul>
                <h3 className="about-us__title">Sekcje redakcyjne</h3>
                <p className="about-us__text">
                    Skąpiec.pl to także inspirujące treści redakcyjne.
                </p>
                <ul>
                    <li className="about-us__item">
                        <div className="about-us__circles" />
                        <div>
                            <h4 className="about-us__header">Sekcja Skąpiec News</h4>
                            <p className="about-us__paragraph">
                                Dostarcza najświeższych informacji ze świata elektroniki i technologii, przybliżając
                                użytkownikom wiadomości o nowych produktach, trendach i firmach technologicznych.
                            </p>
                            <p className="about-us__paragraph">
                                W serwisie publikowane są:
                            </p>
                            <ul className="about-us__list">
                                <li>
                                    newsy – np. informacje o premierach nowych urządzeń;
                                </li>
                                <li>
                                    ciekawostki ze świata technologii;
                                </li>
                                <li>
                                    informacje o promocjach, rabatach i najkorzystniejszych ofertach w różnych
                                    sklepach.
                                </li>
                            </ul>
                        </div>
                    </li>
                    <li className="about-us__item">
                        <div className="about-us__circles" />
                        <div>
                            <h4 className="about-us__header">Sekcja Skąpiec Radzi</h4>
                            <p className="about-us__paragraph">
                                Oferuje rzetelne informacje i opinie, które pomagają użytkownikom w podejmowaniu
                                trafnych decyzji zakupowych. To między innymi:
                            </p>
                            <ul className="about-us__list">
                                <li>
                                    Poradniki zakupowe. Który produkt wybrać? Na co zwrócić uwagę podczas zakupów? Ile
                                    warto wydać na konkretny model? Odpowiadamy na najczęściej zadawane pytania.
                                </li>
                                <li>
                                    Inspiracje. Jakie są obecne trendy? Które ciekawe pomysły można wykorzystać u
                                    siebie? Co sprawdzi się jako prezent na wybraną okazję? Inspirujemy do zakupów oraz
                                    podpowiadamy najlepsze rozwiązania.
                                </li>
                                <li>
                                    Baza wiedzy. Co oznaczają konkretne parametry produktu? Czym różnią się od siebie
                                    wybrane modele? Wyjaśniamy trudne pojęcia oraz fachową terminologię tak, aby zakupy
                                    były w pełni świadome i bezproblemowe.
                                </li>
                                <li>
                                    Recenzje i premiery. Śledząc nasz serwis, nie przegapisz najważniejszych premier
                                    oraz dowiesz się, jak oceniane są najnowsze produkty.
                                </li>
                            </ul>
                        </div>
                    </li>
                </ul>
                <h3 className="about-us__title">O czym piszemy?</h3>
                <p className="about-us__text">
                    Publikujemy artykuły lifestyle’owe, technologiczne, wnętrzarskie. Pojawiają się również wpisy o
                    elektronice, motoryzacji, modzie, pielęgnacji, produktach dla dzieci oraz wiele innych, ciekawych
                    treści.
                </p>
                <h3 className="about-us__title">Historia Skąpiec.pl</h3>
                <ul className="about-us__years">
                    <li className="about-us__year about-us__year--right">
                        <h4 className="about-us__header about-us__header--blue">2023</h4>
                        <p>
                            Dzięki przeprowadzeniu gruntownego redesignu Skąpiec.pl stał się jeszcze bardziej
                            przyjazną, intuicyjną i funkcjonalną platformą dla smart shopperów - to dlatego już od
                            prawie 20 lat korzystają z niej miliony polskich internautów.
                        </p>
                    </li>
                    <li className="about-us__year about-us__year--left">
                        <h4 className="about-us__header about-us__header--blue">2018</h4>
                        <p>
                            Miało miejsce ostateczne połączenie spółek - Firma Ringier Axel Springer Polska przejęła
                            całkowity majątek spółki Skąpiec.pl.
                        </p>
                    </li>
                    <li className="about-us__year about-us__year--right">
                        <h4 className="about-us__header about-us__header--blue">2014</h4>
                        <p>
                            Skąpiec.pl dołączył do Grupy Onet.pl. Przejęcie większościowych udziałów firmy umożliwiło
                            Onetowi rozwój portfolio na rynku serwisów e-commerce.
                        </p>
                    </li>
                    <li className="about-us__year about-us__year--left">
                        <h4 className="about-us__header about-us__header--blue">2004</h4>
                        <p>
                            Skąpiec.pl powstał 13 października 2004. Umożliwił internautom porównywanie cen, a wkrótce
                            także innych warunków zakupu, jak na przykład kosztów dostawy. Do dziś pozostaje jednym z
                            największych w polskim internecie źródeł informacji o produktach i ofertach ich zakupu w
                            sklepach internetowych.
                        </p>
                    </li>
                </ul>
                <div className="about-us__location">
                    <div>
                        <h3 className="about-us__title">Lokalizacja</h3>
                        <p>
                            Ringier Axel Springer Polska sp. z o.o.<br />
                            ul. Domaniewska 49<br />
                            02–672 Warszawa<br />
                            tel.
                            {' '}
                            <a
                                className="about-us__link--phone"
                                href="tel:22-232-0000"
                            >
                                22 232 0000
                            </a>
                        </p>
                    </div>
                    <div>
                        <h3 className="about-us__title">Social Media</h3>
                        <ul className="about-us__socials">
                            <li>
                                <a
                                    href="https://www.facebook.com/Skapiec"
                                    target={LinkTarget.BLANK}
                                    rel={SeoLinkRelEnum.NOFOLLOW_NOOPENER_NOREFERRER}
                                    aria-label="Facebook"
                                >
                                    <Icon
                                        color="dark"
                                        size={48}
                                        name="facebook-filled"
                                    />
                                </a>
                            </li>
                            <li>
                                <a
                                    href="https://www.instagram.com/skapiec_pl/"
                                    target={LinkTarget.BLANK}
                                    rel={SeoLinkRelEnum.NOFOLLOW_NOOPENER_NOREFERRER}
                                    aria-label="Instagram"
                                >
                                    <Icon
                                        color="dark"
                                        size={48}
                                        name="instagram"
                                    />
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </ProductSectionBox>
        <AboutUsStructuredData />
    </section>
);

export default AboutUsBase;
